// src/hooks/useEleve.js
import { useApi } from './useApi';
import { url } from '../../utils/confserveur';
export const useEleve = (eleveId, queryParams = {}, enabled) => {
  // Construire l'URL de base
  let urlfetch = eleveId ? `${url}eleves/${eleveId}` : `${url}eleves/`;

 // Ajouter les query params si présents
 if (Object.keys(queryParams).length > 0) {
  const queryString = Object.entries(queryParams)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
  urlfetch += `?${queryString}`;
}
  return useApi(urlfetch, [], null,enabled);
};